import { CheckCircle } from "@phosphor-icons/react";

export default function UpgradeCard({ id, icon: Icon, eyebrow, name, price, unit, description, included, bestFor, note }) {
  return (
    <div
      data-testid={`tier-${id}`}
      className="relative rounded-md p-7 border border-brand-line bg-white flex flex-col transition-all hover:-translate-y-0.5 hover:shadow-md"
    >
      <div className="flex items-center gap-2.5 mb-4">
        <span className="inline-flex items-center justify-center w-9 h-9 rounded-md bg-brand-copper/10 text-brand-copper">
          <Icon size={18} weight="duotone" />
        </span>
        <span className="text-[10px] uppercase tracking-[0.2em] font-semibold text-brand-copper">
          {eyebrow}
        </span>
      </div>

      <h3 className="font-serif text-2xl text-brand-forest leading-tight">{name}</h3>

      <div className="mt-5 flex items-baseline gap-2 flex-wrap">
        <span className="font-serif text-3xl text-brand-forest">{price}</span>
        <span className="text-sm text-brand-ink/60">{unit}</span>
      </div>

      <p className="mt-5 text-sm leading-relaxed text-brand-ink/70">{description}</p>

      <div className="mt-6">
        <div className="text-[10px] uppercase tracking-[0.16em] font-semibold text-brand-muted mb-3">
          Includes
        </div>
        <ul className="space-y-2 text-sm">
          {included.map((i) => (
            <li key={i} className="flex gap-2 items-start">
              <CheckCircle size={14} weight="fill" className="text-brand-copper mt-1 shrink-0" />
              <span className="text-brand-ink/80">{i}</span>
            </li>
          ))}
        </ul>
      </div>

      {bestFor && (
        <div className="mt-6">
          <div className="text-[10px] uppercase tracking-[0.16em] font-semibold text-brand-muted mb-3">
            Best for
          </div>
          <ul className="space-y-1.5 text-xs">
            {bestFor.map((b) => (
              <li key={b} className="flex gap-2 items-start text-brand-ink/65">
                <span className="text-brand-copper">·</span>
                {b}
              </li>
            ))}
          </ul>
        </div>
      )}

      {note && (
        <p className="mt-5 pt-5 border-t border-brand-line text-xs italic leading-relaxed text-brand-muted">
          {note}
        </p>
      )}
    </div>
  );
}
